import { Guid } from "guid-typescript";
import { FetchInterceptor } from "src/app/helpers/Index";
import { CompanyHoliday } from "../interfaces/Index";
import { environment } from "src/environments/environment";
import { Service } from "./Service";

const endpoint = "CompanyHoliday";
export const CompanyHolidayService = {
	endpoint,
	createSingle: async (data: CompanyHoliday) => await Service.createSingle(endpoint, data),
	deleteSingleById: async (id: number) => await Service.deleteSingleById(endpoint, id),
	forYear: async (year: number) => await FetchInterceptor(`${environment.server.apiURL}/${endpoint}/ForYear/${year}`, {headers: {"Content-Type": "application/json"}, method: "GET"}),
	getAll: async () => await Service.getAll(endpoint),
	getSingleById: async (id: number) => await Service.getSingleById(endpoint, id),
	getSingleByLookupId: async (id: Guid) => await Service.getSingleByLookupId(endpoint, id),
	updateSingleById: async (id: number, data: CompanyHoliday) => await Service.updateSingleById(endpoint, id, data),
}